import React, { useEffect, useRef } from "react";
import { baseUrl } from '../../config.js'
import { useNavigate } from "react-router-dom";
import useToken from '../../useToken.js'
import HeroImg from '../../img/temp/almacen2.jpg';
import './Unirte.css';

const Unirte = ({ user, setModalLogin }) => {
    const { token } = useToken();
    const navigate = useNavigate();
    const contrato = useRef();
    const rootRef = useRef(null);

    useEffect(() => {
        const root = rootRef.current;
        if (!root) return;

        const syncNavHeight = () => {
            let above = 0;
            let el = root.previousElementSibling;
            while (el) {
                const style = window.getComputedStyle(el);
                if (style.display !== 'none' && style.position !== 'fixed' && style.position !== 'absolute') {
                    above += el.getBoundingClientRect().height;
                }
                el = el.previousElementSibling;
            }
            // If Sibling walking missed (e.g. Fragments), fall back to sticky nav
            if (above < 40) {
                const nav = document.querySelector('.contenedor .nav');
                above = nav ? nav.getBoundingClientRect().height : 112;
            }
            root.style.setProperty('--unir-nav-h', `${Math.ceil(above)}px`);
        };

        syncNavHeight();
        window.addEventListener('resize', syncNavHeight);

        const ro = typeof ResizeObserver !== 'undefined'
            ? new ResizeObserver(syncNavHeight)
            : null;
        if (ro) {
            let el = root.previousElementSibling;
            while (el) {
                ro.observe(el);
                el = el.previousElementSibling;
            }
            const nav = document.querySelector('.contenedor .nav');
            if (nav) ro.observe(nav);
        }

        return () => {
            window.removeEventListener('resize', syncNavHeight);
            if (ro) ro.disconnect();
        };
    }, []);

    const aceptar = () => {
        if (contrato.current.reportValidity()) {
            fetch(baseUrl + 'User/AceptarTerminos', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + (token || '')
                },
                body: JSON.stringify({})
            })
                .then(async res => {
                    const data = await res.json().catch(() => ({}));
                    if (!res.ok) {
                        throw new Error(data.message || data.error || 'Error al aceptar términos');
                    }
                    return data;
                })
                .then(() => {
                    navigate('/host');
                })
                .catch((err) => {
                    console.error(err);
                    alert(err.message || 'No se pudo aceptar el consentimiento. Intenta de nuevo.');
                });
        }
    }

    return (
        <main className="unir" ref={rootRef}>
            <section className="unir__hero" aria-label="Bienvenida a anfitriones">
                <img
                    className="unir__photo"
                    src={HeroImg}
                    alt="Interior de un almacén con pasillos y estantería industrial"
                />
                <div className="unir__veil" aria-hidden="true" />

                <div className="unir__content">
                    <div className="unir__copy">
                        <h1>Conviértete en anfitrión</h1>
                        <p>
                            Haz que tu almacén trabaje por ti. Publica tu espacio y empieza
                            a generar ingresos con el inventario que hoy está detenido.
                        </p>

                        <div className="unir__cta">
                            {!user?.sub && (
                                <button
                                    type="button"
                                    className="unir__btn"
                                    onClick={() => setModalLogin(true)}
                                >
                                    Quiero Unirme
                                </button>
                            )}

                            {user?.sub && (
                                <>
                                    <label className="unir__consent">
                                        <input type="checkbox" ref={contrato} required />
                                        <span>
                                            Acepto el{' '}
                                            <a
                                                href="http://file.palletcloud.io/CONTRATO.pdf"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                Consentimiento para el Tratamiento de Datos Personales
                                            </a>
                                            .
                                        </span>
                                    </label>
                                    <button type="button" className="unir__btn" onClick={aceptar}>
                                        Quiero Unirme
                                    </button>
                                </>
                            )}
                        </div>
                    </div>

                    <ol className="unir__flow" aria-label="Cómo empezar">
                        <li>
                            <strong>Publica</strong>
                            <span>Lista tu almacén con fotos, capacidad y disponibilidad.</span>
                        </li>
                        <li>
                            <strong>Recibe</strong>
                            <span>Atiende solicitudes de clientes que buscan espacio cerca.</span>
                        </li>
                        <li>
                            <strong>Gana</strong>
                            <span>Monetiza metros libres con respaldo de la plataforma.</span>
                        </li>
                    </ol>
                </div>
            </section>
        </main>
    )
}

export default Unirte;
